import queryString from "query-string";
import axios from "axios";

// let number = Math.floor(Date.now() / 1000);
// let email = 'james.h+' + number + '@biffbangpow.com';
// let fname = 'James';
// let lname = 'Heathcote';

let formsMixin = {
    data() {
        return {
            loading: false,
            apiError: false,
            validationHasRun: false,
            recaptchaSubmitted: false,
            recaptchaVerified: false,
            email: '',
            fname: '',
            lname: '',
            recaptchaValidationFailedMessage: 'Recaptcha Validation Failed',
        }
    },
    computed: {
        emailIsValid() {
            return this.checkEmailAddressValid(this.email);
        },
        firstNameClass() {
            if (this.validationHasRun === true) {
                if (this.fname === '' || this.fname === undefined) {
                    return 'is-invalid';
                } else {
                    return 'is-valid';
                }
            }

            return '';
        },
        secondNameClass() {
            if (this.validationHasRun === true) {
                if (this.lname === '' || this.lname === undefined) {
                    return 'is-invalid';
                } else {
                    return 'is-valid';
                }
            }

            return '';
        },
        emailClass() {
            if (this.validationHasRun === true) {
                if (this.email === '' || this.email === undefined || this.emailIsValid === false) {
                    return 'is-invalid';
                } else {
                    return 'is-valid';
                }
            }

            return '';
        },
        recaptchaErrorClass() {
            if (this.recaptchaVerified === false && this.recaptchaSubmitted === true) {
                return 'd-block';
            }

            return 'd-none';
        }
    },
    methods: {
        notUndefinedNullOrBlankString(value) {
            return (value !== undefined && value !== null && value !== '');
        },
        async recaptchaVerify(){
            return grecaptcha.execute('6LerqsQqAAAAAPB5s-QpGeMZOQgDSBjxhHDGchCN', {action: 'submit'}).then(this.checkRecaptchaToken);
        },
        async checkRecaptchaToken(token) {

            let urlParams = {
                token: token,
            };

            let url = '/api/recaptchaverify?' + queryString.stringify(urlParams);

            try {
                await axios.get(
                    url,
                    {
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded'
                        }
                    }
                ).then((response) => {
                    let data = response.data;
                    if (data.verified === true) {
                        console.log('Recaptcha token verified');
                        this.recaptchaVerified = true;
                    } else {
                        console.log('Recaptcha token not verified');
                        this.recaptchaVerified = false;
                    }
                    console.log('Recaptcha response finished');
                    this.recaptchaSubmitted = true;
                });

            } catch (err) {
                this.recaptchaVerified = false;
                this.recaptchaSubmitted = true;
                console.log('Recaptcha error');
            }
        },
        recaptchaExpired() {
            this.recaptchaVerified = false;
        },
        checkEmailAddressValid(email) {
            let re = /\S+@\S+\.\S+/;
            return re.test(email);
        },
    },
    created() {

    }
}

export default formsMixin;